import { NotifyHelper } from "../../../helpers/toast";
import { eThiSinhActionsObj } from "../../action-types/tct/IThiSinhActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const thiSinhActions = {
    ...generateActions(eThiSinhActionsObj, "THI_SINH"),
    ...generateActionForKey(eThiSinhActionsObj, "THI_SINH", "SAVE_SUCCESS", () => NotifyHelper.Success("Thành công")),
    ...generateActionForKey(eThiSinhActionsObj, "THI_SINH", "DELETE_SUCCESS", () => NotifyHelper.Success("Thành công")),
    // ...generateActionForKey(eThiSinhActionsObj, "THI_SINH", "SAVE_ERROR", (m) => NotifyHelper.Error(m)),
    // ...generateActionForKey(eThiSinhActionsObj, "THI_SINH", "DELETE_ERROR", (m) => NotifyHelper.Error(m)),
};
